export interface CaptionSegment {
  text: string;
  isHighlight: boolean;
}

export const stripTrailingDots = (text: string): string => text.replace(/[.…]+\s*$/, "");

export const isUnbreakableHighlight = (text: string): boolean => !/\s/.test(text);

/**
 * Splits an already-translated caption into plain + highlighted segments by locating each
 * highlight value inside the text.
 * Each highlight is matched once, in order, on its first occurrence within a plain segment.
 */
export const buildCaptionSegments = (text: string, highlights: string[]): CaptionSegment[] => {
  const segments: CaptionSegment[] = [{ text, isHighlight: false }];

  for (const highlight of highlights) {
    if (!highlight) {
      continue;
    }

    for (let i = 0; i < segments.length; i++) {
      const segment = segments[i];
      if (segment.isHighlight) {
        continue;
      }

      const index = segment.text.indexOf(highlight);
      if (index === -1) {
        continue;
      }

      const before = segment.text.slice(0, index);
      const after = segment.text.slice(index + highlight.length);
      const replacement: CaptionSegment[] = [];
      if (before) {
        replacement.push({ text: before, isHighlight: false });
      }
      replacement.push({ text: highlight, isHighlight: true });
      if (after) {
        replacement.push({ text: after, isHighlight: false });
      }

      segments.splice(i, 1, ...replacement);
      break;
    }
  }

  return segments;
};
